// nationalCodeHelper.js

/**
 * اعتبارسنجی استاندارد کد ملی (الگوریتم ماژول ۱۱)
 * @param {string} nationalCode 
 * @returns {{ isValid: boolean, message: string }}
 */
export function validateNationalCode(nationalCode) {
  if (!nationalCode) {
    return { isValid: false, message: 'کد ملی وارد نشده است' };
  }

  // حذف فاصله و تبدیل ارقام فارسی به انگلیسی
  const code = nationalCode.toString().trim()
    .replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));

  if (!/^\d{10}$/.test(code)) {
    return { isValid: false, message: 'کد ملی باید ۱۰ رقم عددی باشد' };
  }

  // بررسی ارقام تکراری (مانند 0000000000 یا 1111111111)
  if (/^(\d)\1{9}$/.test(code)) {
    return { isValid: false, message: 'کد ملی نامعتبر است' };
  }

  // الگوریتم رسمی ماژول ۱۱
  const checkDigit = parseInt(code.charAt(9), 10);
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(code.charAt(i), 10) * (10 - i);
  }

  const remainder = sum % 11;
  const isValid = (remainder < 2 && checkDigit === remainder) || 
                  (remainder >= 2 && checkDigit === (11 - remainder));

  if (!isValid) {
    return { isValid: false, message: 'رقم کنترل کد ملی اشتباه است' };
  }

  return { isValid: true, message: 'کد ملی معتبر است' };
}
